import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [FormsModule, CommonModule, HttpClientModule,
    ReactiveFormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  myForm!: FormGroup;
  title = 'cds-site-codedialog';
  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  loading = false;
  totalCount: number = 0;

  constructor(private fb: FormBuilder, private http: HttpClient) {
  }
  ngOnInit(): void {
    this.myForm = this.fb.group({
      name: ['', [Validators.required, this.noWhitespaceValidator]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      phone: ['', [Validators.pattern('^[0-9]{10}$')]],
      message: ['']
    });

    //check if totalCount is in session storage
    const storedCount = sessionStorage.getItem('totalCount');
    if (storedCount) {
      this.totalCount = parseInt(storedCount, 10);
    } else {
      this.getTotalCount();
    }
  }

  scrollTo(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      const yOffset = -110; // 👈 110px above the element
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  getTotalCount() {
    const url = 'https://cds-common-api-dev.azurewebsites.net/api/home/visit-count';
    const payload = {
      tenantCode: "CDSSTPL",
    };
    this.http.post(url, payload).subscribe({
      next: (response) => {
        if (response && (response as any).responseCode === 1) {
          //put in session storage
          const setTotalCount = (response as any).totalCount || 0;
          sessionStorage.setItem('totalCount', setTotalCount.toString());
          this.totalCount = sessionStorage.getItem('totalCount') ? parseInt(sessionStorage.getItem('totalCount') || '0', 10) : 0;
        }
      },
      error: (error) => {
        console.error('Error fetching total visitors', error);
      }
    });
  }



  onSubmit(form: FormGroup): void {

    // No need to manually set a 'submitted' flag here if using NgForm's submitted property
    if (form.valid) {
      this.loading = true;
      const url = 'https://cds-common-api-dev.azurewebsites.net/api/home/submit-enquiry';
      const payload = {
        tenantCode: "CDSSTPL",
        name: form.value.name,
        fromEmail: form.value.email,
        fromMobile: form.value.phone,
        fromNote: form.value.message || ''
      };
      this.http.post(url, payload).subscribe({
        next: (response) => {
          if (response && (response as any).responseCode === 1) {
            this.loading = false;
            const respMessage = (response as any).responseMessage || 'Your enquiry has been submitted successfully.';
            alert(respMessage);
            form.reset();
          } else {
            this.loading = false;
            const respMessage = (response as any).responseMessage || 'Your enquiry has failed submitted.';
            alert(respMessage);

          }

        },
        error: (error) => {
          console.error('Error submitting form', error);
        }
      });

    } else {
      this.markAllAsTouched(form);
    }
  }

  markAllAsTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  noWhitespaceValidator(control: FormControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

}
